import { render, staticRenderFns } from "./KelaBatchSummary.vue?vue&type=template&id=68ff95a2&scoped=true&"
import script from "./KelaBatchSummary.vue?vue&type=script&lang=js&"
export * from "./KelaBatchSummary.vue?vue&type=script&lang=js&"
import style0 from "./KelaBatchSummary.vue?vue&type=style&index=0&id=68ff95a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff95a2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VIcon,VRow,VSkeletonLoader,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ff95a2')) {
      api.createRecord('68ff95a2', component.options)
    } else {
      api.reload('68ff95a2', component.options)
    }
    module.hot.accept("./KelaBatchSummary.vue?vue&type=template&id=68ff95a2&scoped=true&", function () {
      api.rerender('68ff95a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KelaBatch/KelaBatchSummary.vue"
export default component.exports